import type { Audience, Team } from './source.ts';

/** Who else sees a file on "My files", in the words `Files.tsx`'s list
 *  draws them in -- `Audience`'s own doc (`source.ts`) maps each kind onto
 *  files#75's references. */
export function audienceLabel(
  audience: Audience,
  teams: readonly Team[],
  companyName: string,
): string {
  switch (audience.kind) {
    case 'me':
      return 'Only you';
    case 'people':
      return audience.subjects.length === 1 ? '1 person' : `${audience.subjects.length} people`;
    case 'team':
      return teams.find((t) => t.id === audience.teamId)?.name ?? 'A team';
    case 'company':
      return `Everyone at ${companyName}`;
  }
}
